<div class="Modal ModalAjudaInadimplente">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Ajuda</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()">
      close
    </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      Por que o refinanciamento de parcelas em atraso é obrigatório?
    </h1>
    <p class="TxtModal text-start">
      É obrigatório pois não é possível criar novos contratos para clientes com
      situação irregular. O refinanciamento permite que o cliente regularize sua
      situação de forma simples, com melhores condições de pagamento.
    </p>
  </div>
  <div class="ModalFooter">
    <div class="row">
      <p class="TxtModal text-start">
        Em caso de dúvidas, ligue para nossa central de atendimento e fale com
        um de nossos atendentes, ou converse por mensagem via WhatsApp:
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-md-5">
        <app-btn-sac></app-btn-sac>
      </div>
      <div class="col-md-7">
        <app-btn-whatsapp></app-btn-whatsapp>
      </div>
    </div>
  </div>
</div>
